export enum BackendErrorEnum {
  FREE_PLAN_LIMITATION = 'FREE_PLAN_LIMITATION',
  MULTIPLE_LINK_NOT_UNIQUE_PARTNER = 'MULTIPLE_LINK_NOT_UNIQUE_PARTNER_EXCEPTION',
}
